import { LANGUAGE_FIELDS } from '@client/feature/activeSubstance/config/filterConfigs';

/**
 * Configuration for treatment search steps
 */
export const SEARCH_STEPS = [
  {
    key: 1,
    title: 'steps.culture.title',
    placeholder: 'steps.culture.placeholder',
    field: 'treatment_cultures.culture',
    document: 'TreatmentDocument',
    label_field: 'french_name',
    value_field: 'id',
    languageConfig: LANGUAGE_FIELDS.cultures,
    autoProgress: true,
    required: true,
  },
  {
    key: 2,
    title: 'steps.culture_practice.title',
    placeholder: 'steps.culture_practice.placeholder',
    field: 'treatment_cultures.cultural_practices',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: true,
    required: true,
  },
  {
    key: 3,
    title: 'steps.treatment_type.title',
    field: 'treatment_type',
    placeholder: 'steps.treatment_type.placeholder',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: true,
    required: true,
  },
  {
    key: 4,
    title: 'steps.application_type.title',
    field: 'application_type',
    placeholder: 'steps.application_type.placeholder',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'name',
    autoProgress: true,
    required: true,
  },
  {
    key: 5,
    title: 'steps.intervention_period.title',
    field: 'intervention_period',
    placeholder: 'steps.intervention_period.placeholder',
    document: 'TreatmentDocument',
    value_field: 'id',
    label_field: 'display_name',
    autoProgress: false,
    required: (selections) => {
      const treatmentTypeLabels = selections?._labels?.['treatment_type'] || [];
      console.log('treatmentTypeLabels', treatmentTypeLabels);
      const test = treatmentTypeLabels.some((item) => {
        const label = item.label || item.name || '';
        return (
          label.includes('herbicides') ||
          label.includes('défanants et aides à la récolte')
        );
      });
      console.log('testtesttest', test);
      return test;
    },
  },
];

export const STEP_STATUS = {
  COMPLETED: 'completed',
  ACTIVE: 'active',
  AVAILABLE: 'available',
  DISABLED: 'disabled',
};

export const AUTO_PROGRESS_DELAY = 200;
export const MIN_STEPS_FOR_SEARCH = 2;
